module.exports = __webpack_public_path__ + "static/media/防控政策.75a28c2f.svg";